export default "__VITE_ASSET__DBB_7Akk__"